module.exports = __webpack_public_path__ + "img/g_habitation.d67530d0.png";